<template>
  <div class="crud" v-loading="loadingAccounts" :element-loading-text="$t('common.loading-please-wait')" :class="{ 'full' : loadingAccounts }">
    <div class="crud-content">
      <div class="header">
        <div class="title">
          <h2>{{ $t('contact-me.chat-center.social-pages.title')}}</h2>
        </div>
        <div class="buttons" v-if="accounts">
          <el-button size="small" type="primary" @click="goToNew" >{{ $t('contact-me.chat-center.social-pages.add-page') }}</el-button>
          <el-button size="small" type="primary" @click="signInWithFacebook" :loading="addingAccount" :disabled="addingAccount">
            {{ !addingAccount ? $t('contact-me.chat-center.social-pages.add-account') : $t('contact-me.chat-center.social-pages.adding-account') }}
          </el-button>
        </div>
      </div>
      <div v-if="!accounts && !loadingAccounts" class="no-account" >
         <img src="/images/facebook_messenger_logo.png" width="100" alt="Facebook Messenger Logo">
        <p>{{ $t("contact-me.chat-center.social-pages.add-your-facebook-account") }}</p>
        <p>{{ $t('contact-me.chat-center.social-pages.associate-the-Facebook-pages-with-HiperMe-and-start-assisting-your-visitor') }}</p>
        <el-button size="small" type="primary" @click="signInWithFacebook" :loading="addingAccount" :disabled="addingAccount">
          {{ !addingAccount ? $t('contact-me.chat-center.social-pages.add-account') : $t('contact-me.chat-center.social-pages.adding-account') }}
        </el-button>
      </div>
       <el-tabs v-model="activeTab" v-if="accounts">
        <el-tab-pane :label="$t('contact-me.chat-center.social-pages.accounts')" name="accounts">
          <TheAccountsTable ref="accountsTable"></TheAccountsTable>
        </el-tab-pane>
        <el-tab-pane :label="$t('contact-me.chat-center.social-pages.pages')" name="pages">
          <ThePagesTable></ThePagesTable>
        </el-tab-pane>
      </el-tabs>
      
    </div>
    <el-dialog :visible.sync="accountLogin">
      <div v-if="accountAdded" class="account-dialog">
        <img src="@/img/success.svg" />
        <p>{{  $t('contact-me.chat-center.social-pages.account-successfully-linked') }}</p>
        <p style="word-break: break-word;">{{ $t('contact-me.chat-center.social-pages.account-successfully-linked-success')  }}</p>
          <div>
            <el-button size="small" type="primary" @click="goToNew">{{ $t('contact-me.chat-center.social-pages.add-page') }}</el-button>
            <el-button size="small" type="text" @click="accountLogin = false">{{ $t('common.maybe-later') }}</el-button>
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/api/http'
import TheAccountsTable from './TheAccountsTable.vue';
import ThePagesTable from './ThePagesTable.vue';
import { loadFacebookSdk, initFacebookSdk } from "@/plugins/facebook-login";
export default {
  data () {
    return {
      loadingAccounts: true,
      accountAdded: null,
      accountLogin: false,
      addingAccount: false,
      activeTab: 'accounts',
    }
  },
  components: {
    ThePagesTable,
    TheAccountsTable,
  },
  methods: {
    login(response) {
      if (response.authResponse) {
        this.addingAccount = true
        const { accessToken, userID } = response.authResponse
        const organizationId = this.$store.getters['contactMe/getOrganizationId']
        http.post("/meta/register", { accessToken, organizationId, userId: userID  })
        .then(({ data }) => {
          this.$refs.accountsTable.fetchData()
          this.accountAdded = data
          this.accountLogin = true
        }).finally(() => {
          this.addingAccount = false
        })
      }
    },
    signInWithFacebook() {
      window.FB.login(this.login, {scope: 'pages_manage_metadata,pages_messaging,pages_show_list'})
    },
    goToNew () {
      this.$router.push({ name: "socialPagesCreate", params: {
        account: this.accountAdded
      }})
    },
    goBack () {
      this.$router.push({ name: "contact-me-chat-center" })
    },
  },
  computed: {
    organizationId () {
      return this.$store.getters["contactMe/getOrganizationId"];
    },
    accounts() {
      return this.$store.getters[`metaAccounts/getData`].length > 0
    },
    fetchingAccounts() {
      return this.$store.getters[`metaAccounts/getFetching`]
    }
  },
  mounted() {
    loadFacebookSdk(document, 'script', 'facebook-jssdk').then(() => {
      initFacebookSdk(process.env.VUE_APP_META_APP_ID)
    })
  },
  watch: {
    fetchingAccounts(val) {
      if (!val && this.loadingAccounts) {
        this.loadingAccounts = false
      }
    }
  },
  created() {
    this.$store.dispatch(`metaAccounts/all`, { ['organization.id'] : this.organizationId  })
  }
};
</script>

<style scoped>
.title {
  display: inline-flex;
  align-items: center;
  gap: var(--column);;
}

.title h2 {
  margin: 0;
}
</style>

<style>
.pageName {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.pageName .icon {
	color: white;
  display: flex;	
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.pageName .icon.facebook {
  background-color: #3b5998 
}

.pageName .icon.instagram {
  background: #d6249f;
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);
}

.full {
  min-width: 100vh;
}

.pageName p.pageId {
  color: grey;
  font-size: 12px;
}

.no-account {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.no-account p {
  text-align: center;
}

.no-account p.first-child {
  font-weight: 500
}

.account-dialog{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
</style>